import { getEnvironment } from './environment';

/**
 * Returns the appropriate email domain based on the current environment.
 * Production: app.getgreenlight.net
 * Staging: staging.getgreenlight.net
 */
export function getEmailDomain(): string {
  return getEnvironment().emailDomain;
}

/**
 * Builds a complete project email address using the appropriate domain.
 */
export function buildProjectEmail(emailPrefix: string): string {
  return `${emailPrefix}@${getEmailDomain()}`;
}
